import { ofType } from "redux-observable";
import { catchError, map, mergeMap, of } from "rxjs";
import {
  actionTypes,
  createConflictFailureAction,
  createConflictSuccessAction,
  createExceptionActionFailure,
  createExceptionActionSuccess,
  deleteConflictExceptionsFailureAction,
  deleteConflictExceptionsSuccessAction,
  deleteSodConflictFailureAction,
  deleteSodConflictSuccessAction,
  editConflictExceptionFailureAction,
  editConflictExceptionSuccessAction,
  getAllCreateExceptionUsersFailureAction,
  getAllCreateExceptionUsersSuccessAction,
  getAllEntitlementsFailureAction,
  getAllEntitlementsSuccessAction,
  getConflictExceptionsFailureAction,
  getConflictExceptionsSuccessAction,
  getSodConflictsFailureAction,
  getSodConflictsSuccessAction,
  updateConflictTypeFailureAction,
  updateConflictTypeSuccessAction,
} from "./actions";
import {
  fetchCreateConflict,
  fetchCreateException,
  fetchDeleteConflictException,
  fetchDeleteSodConflict,
  fetchEditConflictException,
  fetchGetAllEntitlements,
  fetchGetAllUsers,
  fetchGetConflictException,
  fetchGetSodConflicts,
  fetchModifyConflictType,
} from "./services";

// STEP ONE
const fetchGetSodConflictsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_SOD_CONFLICTS),
    mergeMap(() =>
      fetchGetSodConflicts().pipe(
        map((response: any) => getSodConflictsSuccessAction(response)),
        catchError((error: any) => of(getSodConflictsFailureAction(error)))
      )
    )
  );
const fetchDeleteSodConFlictEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.DELETE_SOD_CONFLICT),
    mergeMap((action: any) =>
      fetchDeleteSodConflict(action.payload).pipe(
        map((response: any) => deleteSodConflictSuccessAction(response)),
        catchError((error: any) => of(deleteSodConflictFailureAction(error)))
      )
    )
  );

// CONFLICT CREATION
const fetchGetAllEntitlementsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_ALL_ENTITLEMENTS),
    mergeMap((action: any) =>
      fetchGetAllEntitlements(action.payload).pipe(
        map((response: any) => getAllEntitlementsSuccessAction(response)),
        catchError((error: any) => of(getAllEntitlementsFailureAction(error)))
      )
    )
  );

// CONFLICT CREATION SUMMARY
const fetchCreateConflictEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.CREATE_CONFLICT),
    mergeMap((action: any) =>
      fetchCreateConflict(action.payload).pipe(
        map((response: any) => createConflictSuccessAction(response)),
        catchError((error: any) => of(createConflictFailureAction(error)))
      )
    )
  );

// CONFLICT DETAILS
const fetchModifyConflictTypeEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.UPDATE_CONFLICT_TYPE),
    mergeMap((action: any) =>
      fetchModifyConflictType(action.payload).pipe(
        map((response: any) => updateConflictTypeSuccessAction(response)),
        catchError((error: any) => of(updateConflictTypeFailureAction(error)))
      )
    )
  );

// EXCEPTION MANAGEMENT
const fetchGetConflictExceptionEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_CONFLICT_EXCEPTIONS),
    mergeMap((action: any) =>
      fetchGetConflictException(action.payload).pipe(
        map((response: any) => getConflictExceptionsSuccessAction(response)),
        catchError((error: any) =>
          of(getConflictExceptionsFailureAction(error))
        )
      )
    )
  );
const fetchEditConflictExceptionEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.EDIT_CONFLICT_EXCEPTION),
    mergeMap((action: any) =>
      fetchEditConflictException(
        action.payload.exceptionId,
        action.payload.body
      ).pipe(
        map((response: any) => editConflictExceptionSuccessAction(response)),
        catchError((error: any) =>
          of(editConflictExceptionFailureAction(error))
        )
      )
    )
  );
const fetchDeleteConflictExceptionEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.DELETE_CONFLICT_EXCEPTIONS),
    mergeMap((action: any) =>
      fetchDeleteConflictException(action.payload).pipe(
        map((response: any) => deleteConflictExceptionsSuccessAction(response)),
        catchError((error: any) =>
          of(deleteConflictExceptionsFailureAction(error))
        )
      )
    )
  );

// CREATE EXCEPTION
const fetchGetAllUsersEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_ALL_CREATE_EXCEPTION_USERS),
    mergeMap((action: any) =>
      fetchGetAllUsers(action.payload).pipe(
        map((response: any) =>
          getAllCreateExceptionUsersSuccessAction(response)
        ),
        catchError((error: any) =>
          of(getAllCreateExceptionUsersFailureAction(error))
        )
      )
    )
  );
const fetchCreateExceptionEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.CREATE_EXCEPTION),
    mergeMap((action: any) =>
      fetchCreateException(action.payload).pipe(
        map((response: any) => createExceptionActionSuccess(response)),
        catchError((error: any) => of(createExceptionActionFailure(error)))
      )
    )
  );

// eslint-disable-next-line import/no-anonymous-default-export
export default [
  fetchGetSodConflictsEpic,
  fetchDeleteSodConFlictEpic,
  fetchGetAllEntitlementsEpic,
  fetchCreateConflictEpic,
  fetchModifyConflictTypeEpic,
  fetchGetConflictExceptionEpic,
  fetchEditConflictExceptionEpic,
  fetchDeleteConflictExceptionEpic,
  fetchGetAllUsersEpic,
  fetchCreateExceptionEpic,
];
